import { DashboardComponent } from "./dashboard.component"

export const DashboardContainer = () => {
   return <DashboardComponent></DashboardComponent>
}
